(ns client-portal.client.voice-insights.tag-data
  (:require [clojure.string :as s]))

(def sessions-table-hidden-utterance-tag-names #{"phase" "crew-upsell" "confirmation" "escalation" "menu-item"
                                                 "ordered-menu-item" "unavailable-menu-item" "suggested-menu-item"
                                                 "utterance-sentiment" "intent-utterance" "utterance-crew-friendliness"
                                                 "user-order" "upsell-response" "customer-upsell" "speaker-turn" "hold"
                                                 "transfer"})
(def sessions-table-hidden-utterance-tag-names-without-roles {"bot-issue" [:every [:admin]]})
(def sessions-table-hidden-utterance-tag-names-excluding-menu-items (disj sessions-table-hidden-utterance-tag-names
                                                                          "ordered-menu-item"
                                                                          "unavailable-menu-item"
                                                                          "suggested-menu-item"))
(def conversation-drawer-hidden-utterance-tag-names #{"utterance-crew-friendliness" "utterance-sentiment" "menu-item"
                                                      "ordered-menu-item" "suggested-menu-item" "unavailable-menu-item"
                                                      "customer-upsell" "speaker-turn"})
(def conversation-drawer-hidden-utterance-tag-names-within-card-only #{"phase" "intent-utterance"})
(def key-metrics-hidden-tag-names #{:call-summary-turns :hold-summary :call-summary-counts :call-summary-timing
                                    :crew-ces-score :ces-score :trailing-audio-duration :post-order-duration})

;; These must be hex values (for bg colors we use a function to convert to rgba)
(def green-tag-color "#4AC53F")
(def red-tag-color "#F63535")
(def blue-tag-color "#0279FF")
(def yellow-tag-color "#F1C066")
(def gray-tag-color "#B2B2B2")
(def purple-tag-color "#9780FF")

(def marketing-color "#00A8DD")
(def efficiency-color "#7247FF")
(def satisfaction-color "#19E39A")
(def outcomes-color gray-tag-color)

(defn utterance-tag-name->color [tag-name]
  (condp contains? tag-name
    ;; Utterance Tags
    #{"crew-upsell" "customer-upsell" "upsell-response"} green-tag-color

    #{"issue" "escalation" "unavailable" "bot-issue"} red-tag-color

    #{"question" "pickup" "confirmation" "interruption"} blue-tag-color

    #{} yellow-tag-color

    ;; Conversation Tags
    #{"combo-upsell" "size-upsell" "add-on-upsell"} marketing-color

    #{"start" "pace"} efficiency-color

    #{"greeting" "sentiment"} satisfaction-color

    #{"outcome" "ai-outcome"} outcomes-color

    gray-tag-color))

(defn conversation-tag-name->color [tag-name]
  (condp contains? tag-name
    ;; Utterance Tags
    #{"intent-summary"} purple-tag-color

    #{"improvement-recommendation"} yellow-tag-color

    gray-tag-color))

(defn tag-color->icon [tag-color]
  (condp = tag-color
    green-tag-color
    :shopping-bag

    red-tag-color
    :warning

    blue-tag-color
    :info

    yellow-tag-color
    :info

    :info))

(defn outcome-tag-color [tag]
  (if (some #(s/includes? (:value tag) %)
            ["takeover" "escalation" "driveoff"])
    "#f63535"
    "rgba(0, 0, 0, 0.80)"))

(defn utterance-tag-name->icon [tag-name]
  (-> (utterance-tag-name->color tag-name)
      (tag-color->icon)))

(def tag-name-roles
  {"bot-issue" [:every [:admin]]})

(def tags-names-to-remove-from-sessions-filter #{"summary" "menu-item" "ordered-menu-item" "suggested-menu-item"
                                                 "unavailable-menu-item" "user-sentiment"})

;; Now just pulling in all tags for last 90 days for concept
#_(def session-filter-tag-options
    [{:name "crew-upsell" :value "combo"}
     {:name "crew-upsell" :value "size"}
     {:name "crew-upsell" :value "add-on"}
     {:name "issue" :value "crew-frustrated"}
     {:name "issue" :value "user-frustrated"}
     {:name "issue" :value "unavailable-discount"}
     {:name "issue" :value "user-repetition"}
     {:name "issue" :value "crew-cant-hear"}
     {:name "issue" :value "user-cant-hear"}
     {:name "issue" :value "wait"}
     {:name "bot-issue" :value "ordinal-failure" :required-roles [:every [:admin]]}
     {:name "bot-issue" :value "cart-modification-failure" :required-roles [:every [:admin]]}
     {:name "bot-issue" :value "did-not-understand" :required-roles [:every [:admin]]}
     {:name "bot-issue" :value "unsupported-intent" :required-roles [:every [:admin]]}
     {:name "bot-issue" :value "item-description-needed" :required-roles [:every [:admin]]}
     {:name "bot-issue" :value "quantity-issue" :required-roles [:every [:admin]]}
     {:name "question" :value "user-menu"}
     {:name "question" :value "user-pricing"}
     {:name "pickup" :value "online-order"}
     {:name "pickup" :value "delivery-driver"}
     {:name "customer-upsell" :value "combo-accept"}
     {:name "customer-upsell" :value "combo-decline"}
     {:name "customer-upsell" :value "size-accept"}
     {:name "customer-upsell" :value "size-decline"}
     {:name "customer-upsell" :value "add-on-accept"}
     {:name "customer-upsell" :value "add-on-decline"}
     {:name "sentiment" :value "positive"}
     {:name "sentiment" :value "negative"}
     {:name "sentiment" :value "neutral"}
     {:name "greeting" :value "positive"}
     {:name "greeting" :value "negative"}
     {:name "greeting" :value "neutral"}
     {:name "pace" :value "slow"}
     {:name "pace" :value "normal"}
     {:name "pace" :value "fast"}
     {:name "start" :value "on-time"}
     {:name "start" :value "delayed"}
     {:name "combo-upsell" :value "offered"}
     {:name "combo-upsell" :value "not-offered"}
     {:name "size-upsell" :value "offered"}
     {:name "size-upsell" :value "not-offered"}
     {:name "add-on-upsell" :value "offered"}
     {:name "add-on-upsell" :value "not-offered"}
     {:name "ai-outcome" :value "takeover"}
     {:name "ai-outcome" :value "ai-escalation"}
     {:name "ai-outcome" :value "customer-escalation"}
     {:name "ai-outcome" :value "ai-fulfilled"}
     {:name "ai-outcome" :value "takeover-ai_crew"}
     {:name "ai-outcome" :value "takeover-pickup"}
     {:name "ai-outcome" :value "takeover-ai_only"}
     {:name "outcome" :value "fulfilled"}
     {:name "outcome" :value "online-pickup"}
     {:name "outcome" :value "delivery-pickup"}
     {:name "outcome" :value "undetermined"}
     {:name "unavailable" :value "out-of-stock"}
     {:name "unavailable" :value "technical-issue"}
     {:name "unavailable" :value "cooking-delay"}
     {:name "unavailable" :value "digital-restriction"}
     {:name "unavailable" :value "time-restriction"}
     {:name "unavailable" :value "lto-discontinued"}
     {:name "unavailable" :value "flavor-topping-restriction"}
     {:name "unavailable" :value "quantity-restriction"}
     {:name "unavailable" :value "item-restriction"}
     {:name "unavailable" :value "dietary"}
     {:name "unavailable" :value "off-menu"}
     {:name "unavailable" :value "other-unknown"}
     ])

(defn tag->description [tag]
  (get {["crew-upsell" "combo"] "Crew upsells a combo, meal or similar"
        ["crew-upsell" "size"] "Crew prompts for a size upgrade"
        ["crew-upsell" "add-on"] "Crew prompts customers to add an extra item or LTO"
        ["customer-upsell" "combo-accept"] "Customer accepts a crew combo offer"
        ["customer-upsell" "combo-decline"] "Customer declines a crew combo offer"
        ["customer-upsell" "size-accept"] "Customer accepts a crew upsize offer"
        ["customer-upsell" "size-decline"] "Customer declines a crew upsize offer"
        ["customer-upsell" "add-on-accept"] "Customer accepts a crew add-on offer"
        ["customer-upsell" "add-on-decline"] "Customer declines a crew add-on offer"
        ["issue" "crew-frustrated"] "Crew expresses frustration, annoyance, sarcasm, or a negative emotional response"
        ["issue" "user-frustrated"] "Customer expresses frustration, annoyance, sarcasm, or a negative emotional response"
        ["issue" "user-repetition"] "Customer repeats phrasing multiple times for clarification"
        ["issue" "crew-cant-hear"] "Crew expresses trouble hearing or understanding the customer"
        ["issue" "user-cant-hear"] "Customer expresses trouble hearing or understanding the crew"
        ["issue" "online-order-not-found"] "Crew cannot verify a customer's online order"
        ["issue" "delivery-order-not-found"] "Crew cannot verify a delivery driver's order"
        ["question" "user-menu"] "Customer asks a question about a menu item"
        ["question" "user-pricing"] "Customer inquires about the cost of an item"
        ["pickup" "online-order"] "Customer requests to pick up an order placed online or through a mobile app"
        ["pickup" "delivery-driver"] "Delivery driver, such as Door Dash or Uber Eats, requests to pick up an order"
        ["confirmation" "order"] "Crew confirms the customers order or ask the customer to pull forward"
        ["confirmation" "online-order"] "Crew confirms an order placed online or through a mobile app"
        ["confirmation" "delivery-order"] "Crew confirms a delivery driver's order"
        ["unavailable" "out-of-stock"] "Crew informs the customer that an item is out of stock"
        ["unavailable" "technical-issue"] "Crew informs the customer that a machine or other kitchen equipment is inoperable"
        ["unavailable" "cooking-delay"] "Crew informs the customer of a wait or delay because items are not ready"
        ["unavailable" "digital-restriction"] "Crew informs the customer that an item is only available online or through a mobile app"
        ["unavailable" "time-restriction"] "Crew tells the customer that a requested item is only available on other dayparts or days"
        ["unavailable" "lto-discontinued"] "Crew tells the customer that the requested item is no longer available"
        ["unavailable" "flavor-topping-restriction"] "Crew informs that the requested item modification is not possible"
        ["unavailable" "quantity-restriction"] "Crew tells the customer that they cannot order the requested quantity"
        ["unavailable" "item-restriction"] "Crew tells the customer that meal/item composition, option or size is restricted"
        ["unavailable" "dietary"] "Crew informs the customer that a dietary request – such as halal, kosher, vegan, vegetarian, allergen – is not available"
        ["unavailable" "off-menu"] "Crew informs the customer that the item is not offered on the menu or at the restaurant at all"
        ["unavailable" "other-unknown"] "Item unavailable due to other reasons"
        ["ai-outcome" "ai-fulfilled"] "The AI bot successfully takes the customer's order"
        ["ai-outcome" "ai-escalation"] "The AI bot automatically escalates the session to a human order taker"
        ["ai-outcome" "customer-escalation"] "A human crew member takes over the session upon customer request"
        ["ai-outcome" "takeover-ai_only"] "A human crew member manually takes over the session and audio capture stops when the crew steps in. Only the AI ordering portion is available."
        ["ai-outcome" "takeover-ai_crew"] "A human crew member manually takes over the session and audio capture also contains the crew/customer conversation"
        ["ai-outcome" "takeover-pickup"] "A human crew member manually takes over the session to handle an online or delivery driver pickup"
        }
       [(:name tag) (:value tag)]))

(defn remove-internal-children [children]
  (vec (remove (fn [child]
                 (some-> (:name child) (name) (s/lower-case) (s/starts-with? "internal/")))
               children)))

(defn remove-internal-tags [tags]
  (->> tags
       (remove #(some-> (:name %) (name) (s/lower-case) (s/starts-with? "internal/")))
       (vec)
       (mapv #(update % :children remove-internal-children))))
